import { arrayOf, bool, func, number, oneOfType, shape, string } from "prop-types";
import React, { useRef } from "react";

import styled from "styled-components/macro";

import { FnrPopoverOption, FnrPopoverOptionsList } from "UI/FnrPopover2";

SelectList.propTypes = {
  label: string,
  icon: string,
  options: arrayOf(
    shape({
      ID: oneOfType([number, string]),
      name: string,
    })
  ),
  selectedID: oneOfType([number, string]),
  handleSelection: func,
  placeholder: string,
  show: bool,
  togglePopover: func,
};

export default function SelectList({
  icon,
  options,
  selectedID,
  handleSelection,
  label,
  placeholder,
  show,
  togglePopover,
}) {
  const buttonRef = useRef();

  const selectionName = options?.find(
    (option) => option.ID === selectedID
  )?.name;

  const onSelection = (ID) => {
    handleSelection(ID);
    togglePopover();
  };

  return (
    <SelectListWrapper>
      <Icon className={icon} />
      <InnerWrapper>
        <Label>{label}</Label>
        <Selection
          ref={buttonRef}
          onClick={togglePopover}
          disabled={!options?.length}
        >
          <span>{selectionName || placeholder}</span>
          <Chevron
            className={
              show ? "fas fa-chevron-right rotate" : "fas fa-chevron-right"
            }
          />
        </Selection>

        <FnrPopoverOptionsList show={show} buttonRef={buttonRef}>
          {options?.map((option) => (
            <FnrPopoverOption
              key={`${option.ID}`}
              disabled={option.disabled}
              onClick={() => onSelection(option.ID)}
              selected={selectedID === option.ID}
            >
              <Option
                $level={option.level || 0}
                data-element="fnr-popover-option"
              >
                {Boolean(option.image) && (
                  <img src={option.image} alt="group icon" />
                )}
                <span data-element="fnr-popover-option">{option.name}</span>
              </Option>
            </FnrPopoverOption>
          ))}
        </FnrPopoverOptionsList>
      </InnerWrapper>
    </SelectListWrapper>
  );
}

const SelectListWrapper = styled.div`
  display: flex;
  gap: 12px;

  box-sizing: border-box;
  width: 100%;
  position: relative;
  color: #475b68;
  background: linear-gradient(
    -2deg,
    #ffffff 60%,
    #fdfdfd,
    #fbfbfc,
    #f8f9fa,
    #f6f7f8
  );
  border-radius: 7px;
  border: 1px solid #98a4a5;
  padding: 6px;
`;

const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 22px;
  width: 30px;
`;

const InnerWrapper = styled.div``;

const Label = styled.div`
  font-size: 12px;
  text-transform: uppercase;
  color: #828c8d;
  font-weight: 400;
  line-height: 15px;
`;

const Chevron = styled.span`
  margin-left: 8px;
  font-size: 14px;
  transition: transform 75ms;

  &.rotate {
    transform: rotate(90deg);
  }
`;

const Selection = styled.div`
  font-weight: 400;
  cursor: pointer;
  ${(props) =>
    props.disabled &&
    `
    opacity: 0.6;
    cursor: not-allowed;
  `}
`;

const Option = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  padding-inline-start: ${({ $level }) => $level * 24}px;

  & img {
    height: 16px;
    width: 16px;
  }
`;
